import { render, staticRenderFns } from "./CustomTableWithRoom.vue?vue&type=template&id=2295979f&scoped=true&"
import script from "./CustomTableWithRoom.vue?vue&type=script&lang=js&"
export * from "./CustomTableWithRoom.vue?vue&type=script&lang=js&"
import style0 from "./CustomTableWithRoom.vue?vue&type=style&index=0&id=2295979f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295979f",
  null
  
)

export default component.exports